import React from "react"

// =============================================================================
// Props
// =============================================================================

export type NavigationDockActionsProps = {
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const actionsStyles = [
  "pointer-events-auto",
  "flex items-center shrink-0",
  "p-1 gap-1",
  "h-12 rounded-full",
  "bg-white ring-1 ring-inset ring-gray-200"
].join(" ")

// =============================================================================
// Component
// =============================================================================

/**
 * A bordered pill that groups the main navigation action buttons.
 */
export function NavigationDockActions({ children }: NavigationDockActionsProps) {
  return (
    <div data-slot="navigation-dock-actions" className={actionsStyles}>
      {children}
    </div>
  )
}

NavigationDockActions.displayName = "Navigation.Dock.Actions"
